import React, { useEffect, useState } from 'react';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import '../css/Testimonials.css';

const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'reviews'));
        const fetchedReviews = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setReviews(fetchedReviews);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };

    fetchReviews();
  }, []);

  return (
    <section className="testimonials-section py-5 text-center">
      <div className="container">
        <h2 className="section-title mb-4">What Our Customers Say</h2>
        {reviews.length > 0 ? (
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            spaceBetween={30}
            slidesPerView={1}
          >
            {reviews.map(({ id, author, text }) => (
              <SwiperSlide key={id}>
                <div className="testimonial-card">
                  <p className="feedback">“{text}”</p>
                  <h6 className="name mt-3">- {author}</h6>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p>No reviews yet.</p>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
